import { useState } from "react";

export default function Migration() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

const migrate = async () => {
  try {
    setLoading(true);
    setMessage("");

    const response = await fetch(
      "https://server.account.majestyfx.com/user_migration.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
        }),
      }
    );

    console.log("Status:", response.status);

    const text = await response.text();

    console.log("Response:", text);

    try {
      const data = JSON.parse(text);
      setMessage(data.message);
    } catch {
      setMessage("Server did not return valid JSON.");
    }

  } catch (err) {
    console.error(err);
    setMessage(err.message);
  } finally {
    setLoading(false);
  }
};

  return (
    <div
      style={{
        padding: "40px",
        background: "#f5f7fb",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "700px",
          margin: "auto",
          background: "#fff",
          borderRadius: "12px",
          padding: "35px",
          boxShadow: "0 10px 30px rgba(0,0,0,.08)",
        }}
      >
        <h2
          style={{
            marginBottom: "10px",
            color: "#0d6efd",
          }}
        >
          User Migration
        </h2>

        <p
          style={{
            color: "#666",
            marginBottom: "30px",
          }}
        >
          Transfer a client and all related records from the Main CRM
          database to the Account CRM database.
        </p>

        <div
          style={{
            background: "#eef6ff",
            border: "1px solid #b6d4fe",
            padding: "15px",
            borderRadius: "8px",
            marginBottom: "25px",
          }}
        >
          <strong>Migration Details</strong>

          <ul style={{ marginTop: "10px" }}>
            <li>Migrate <b>Users</b></li>
           
            <li>Migration Key: <b>Email Address</b></li>
          </ul>
        </div>

        <label
          style={{
            fontWeight: "600",
          }}
        >
          Client Email
        </label>

        <input
          type="email"
          placeholder="Enter client email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "8px",
            marginBottom: "20px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "15px",
          }}
        />

        <button
          onClick={migrate}
          disabled={loading}
          style={{
            background: "#198754",
            color: "#fff",
            border: "none",
            padding: "12px 30px",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          {loading ? "Migrating..." : "Transfer User"}
        </button>

        {message && (
          <div
            style={{
              marginTop: "25px",
              padding: "15px",
              borderRadius: "8px",
              background: "#e8f5e9",
              color: "#155724",
              fontWeight: "600",
            }}
          >
            {message}
          </div>
        )}
      </div>
    </div>
  );
}